import Steps from "./Steps";

const CompanyDetailsForm1 = ({ setFormNum, setFormData, formData }) => {

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  function handleSubmit(e){
    e.preventDefault();
    const requiredFields = ['full_name', 'email'];
    setFormData(prevFormData => {
      const missingFields = requiredFields.filter(
        field => !prevFormData?.[field] || prevFormData[field].trim() === ''
      );
      if (missingFields.length > 0) {
        alert(`Please fill all required fields: ${missingFields.join(', ')}`);
        return prevFormData;
      }
      setFormNum((prev) => prev + 1);
      return prevFormData;
    });
  }

  return (
    <div className="container mx-auto mt-8 px-4 sm:px-0 2xl:mt-4 space-y-4 font-inter">
      <form onSubmit={handleSubmit}>
        <div>
          <Steps stepNum={1} setFormNum={setFormNum}/>
          <h2 className="text-xl md:text-2xl 2xl:text-3xl 2xl:mb-4 2xl:ml-1 font-semibold text-[#111827] ml-1 mb-4">Company Details</h2>
          
            <div>
              <input
                type="text"
                id="fullName"
                name="full_name"
                placeholder="Full name*"
                onChange={handleChange}
                value={formData.full_name}
                className="w-full px-4 py-2 mb-4 2xl:py-3 2xl:text-lg border border-[#CAD0D9] text-[#5F5F5F] rounded-lg"
                required
              />
            </div>

            <div>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email*"
                onChange={handleChange}
                value={formData.email}
                className="w-full px-4 py-2 mb-4 2xl:py-3 2xl:text-lg border border-[#CAD0D9] text-[#5F5F5F] rounded-lg"
                required
                // onKeyDown={(e) => e.key === 'Enter' && handleClick()}
              />
            </div>
        </div>
          <div>
            <button
              type="submit"
              className="w-full px-4 py-2 2xl:py-3 text-white bg-[#5D5D5D] rounded-lg xl:text-lg"
            >
              Next
            </button>
          </div>
      </form>
    </div>
  );
};

export default CompanyDetailsForm1;